import { z } from "zod";

/*
 * Imported first in main.tsx. Zod probes for `new Function` once to decide
 * whether it may compile fast paths; under the portal's CSP (no eval) the
 * probe is refused and logged as a violation on every page. Saying so up
 * front skips the probe - the parsers are the same, just not compiled.
 */
z.config({ jitless: true });
